import {
  CHANGE_VEHICLE,
  CHANGE_USER,
  CHANGE_POLICY,
  CHANGE_DOCUMENTS,
  CHANGE_CLAIM
} from './constants'

import { VEHICLE_DETAIL_URL }  from 'constants'

import request from 'utils/request'


export const vehicleChanged = (vehicle) => {
  return {
    type: CHANGE_VEHICLE,
    vehicle
  }
}

export const policyChange = (policy) => {
  return {
    type: CHANGE_POLICY,
    policy
  }
}

export const refreshPolicy = () => {
  return (dispatch, getState) => {
    const state = getState().vehicleDetail
    const uuid = state.get('user').get('uuid'),
      vehicleId = state.get('vehicle').get('id')
    // retrieve active policy for this vehicle
    return request(VEHICLE_DETAIL_URL(uuid, vehicleId))
           .then(({policy}) => dispatch(policyChange(policy)))
           .catch(console.log)
  }
}

export const userChanged = (user) => {
  return {
    type: CHANGE_USER,
    user
  }
}

export const documentsChanged = (documents) => {
  return {
    type: CHANGE_DOCUMENTS,
    documents
  }
}
export const claimChanged = (claim) => {
  return {
    type: CHANGE_CLAIM,
    claim
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/actions.js